import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleSignedKyc, updateEsignStatus } from "./redux/action";
import Title from "../../components/Title";
import Button from "../../components/Button";
import { checkEsignUrl } from "./redux/action";
import { getDocumentId } from "../Review/redux/action";

const ESignature = () => {
  const on_screen_esign = window.sessionStorage.getItem("on_screen_esign");
  const dispatch = useDispatch();

  const {
    kyc_esign,
    kra_esign
  } = useSelector((state) => state.navigation);
  const { loading, kyc_doc_id, kra_doc_id, user, kra_gwt, kyc_gwt } = useSelector((state) => state.review);
  const [progressTimer, setProgressTimer] = useState(0);
  const [isKycSigned, setIsKycSigned] = useState(false);
  const [isKraSigned, setIsKraSigned] = useState(false);

  useEffect(() => {
    if(on_screen_esign != 0){
      dispatch(getDocumentId())
    }
  }, [])




  const checkToRedirect = () => {
    if(!isKycSigned){
      movetoDigitalSignature(kyc_doc_id, 'kyc', kyc_gwt)
    }else if(!isKraSigned){
      movetoDigitalSignature(kra_doc_id, 'kra', kra_gwt)
    }
  }

  useEffect(() => {
    if(on_screen_esign != 0){
      setTimeout(() => {
        checkToRedirect()
      },1000)
    }
  },[isKraSigned, isKycSigned])

  useEffect(() => {
    if(on_screen_esign != 0){
    if(kyc_esign){
      setIsKycSigned(true)
    }
    if(kra_esign){
      setIsKraSigned(true)
    }
  }
    
    
  },[kyc_esign, kra_esign])



  
  useEffect(() => {
    if(on_screen_esign != 0){
    let timeoutId; // Declare a variable to hold the timeout ID
  
    const callFunctionEveryTenSeconds = () => {
      if (!kyc_esign) {
        dispatch(getDocumentId());
  
        // Set the timeout and store its ID
        timeoutId = setTimeout(callFunctionEveryTenSeconds, 20000); 
      }
    };
  
    callFunctionEveryTenSeconds(); // Initial call
  
    // Cleanup function to clear the specific timeout
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }
  }, [kyc_esign, kra_esign]);


  useEffect(() => {
    if(on_screen_esign != 0){
    if (kra_doc_id && progressTimer < 95) {
      setProgressTimer(98);
    }
  
    const totalUpdates = 180 * 10; // 180 seconds * 10 times per second
    const incrementPerUpdate = 100 / totalUpdates; // Total progress divided by number of updates
  
    if (progressTimer < 100) {
      const timerId = setInterval(() => {
        setProgressTimer((prev) => {
          const newProgress = prev + incrementPerUpdate;
          return newProgress > 100 ? 100 : newProgress;
        });
      }, 100);
  
      return () => clearInterval(timerId);
    } else {
      dispatch(getDocumentId());
      checkToRedirect();
    }
  }
  }, [progressTimer]);
  
  



  const handleSigningSuccess = (type) => {
    // Define payload based on the document type
    let payload = {};
    if (type === 'kyc') {
      payload.kyc_esign ='1';
    } else if (type === 'kra') {
      payload.kra_esign = '1';
    }
  
    // Call the API to update the esign status
    dispatch(updateEsignStatus(payload));
  };

  const movetoDigitalSignature = (docId, type, token) => {
    const logo = window.sessionStorage.getItem("logo");
    if (docId) {
      // Define the options for DIGIO SDK
      const options = {
        environment: "production",
        callback: function (response) {
          if (response.hasOwnProperty("error_code")) {
            console.error("Error occurred:", response.message);
          } else {
            console.log("Signing completed successfully", response);
            // Update state based on the document type
            if (type === 'kyc') {
              setIsKycSigned(true);
            } else if (type === 'kra') {
              setIsKraSigned(true);
            }
            handleSigningSuccess(type);
          }
        },
        logo: logo,
        // ... other options
      };
      try{
        setTimeout(() => {
          const digio = new window.Digio(options);
          digio.init();
          digio.submit(docId, user, token); // Use user as the identifier
        },300)
        
      }catch(error){
        console.log(error)
      }
    } else {
      console.log("Document ID is not available");
    }
  };


  const getTitle = () => {
    let html = "eSign";
    if (isKraSigned && isKycSigned) {
      html = "Thank You!";
    }
    return html;
  };
  return (
    <React.Fragment>
      <Title title={getTitle()} />
      {(on_screen_esign != 0) ? (
      <div className="col-md-10 mt-3">
        {progressTimer != 100 && <div className="">
          <p>We are preparing your document for eSign Please wait</p>
          <div className="progress">
            <div
              className="progress-bar"
              role="progressbar"
              style={{ width: `${parseInt(progressTimer)}%` }}
              aria-valuenow={parseInt(progressTimer)}
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {progressTimer.toFixed(2)}
            </div>
          </div>
        </div>}
        {(progressTimer == 100) &&
        <>
        {isKraSigned && isKycSigned ?
          <h3>Your Documents are signed successfully</h3> :
          <>
            <Button
              type="button"
              title="eSign KYC"
              handleClick={() => movetoDigitalSignature(kyc_doc_id, 'kyc', kyc_gwt)}
              disabled={isKycSigned}
            />
            <div className="mt-2"></div>
            {/* {progressTimer > 0 && <span>Please wait... You will be redirected to eSign the document in {progressTimer} seconds.</span>} */}
            <Button
              type="button"
              title="eSign KRA"
              handleClick={() => movetoDigitalSignature(kra_doc_id, 'kra', kra_gwt)}
              disabled={isKraSigned}
            />
          </>
        }
        </>}
      </div>):(
        <div>
          <h3 className="lh-base">
              eSign email is sent to your Inbox, please complete esign. Once done
              successfully, you will be notified by our team.
            </h3>
        </div>
      )}
    </React.Fragment>
  );
};

export default ESignature;
